let TimezoneUtil = {
  getShortTimezoneStr: (zone) => {
    var s = '';

    switch (zone) {
      case 'EDT':
      case 'EST':
        s = 'E.T.';
        break;
      case 'CDT':
      case 'CST':
        s = 'C.T.';
        break;
      case 'PDT':
      case 'PST':
        s = 'P.T.';
        break;
      case 'MDT':
      case 'MST':
        s = 'M.T.';
        break;
      case 'AKDT':
      case 'AKST':
        s = 'A.T.';
        break;
      case 'HST':
        s = 'H.T.';
        break;
      default:
        break;
    }

    return s;
  },
};

export default TimezoneUtil;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/util/TimezoneUtil.js